module.exports = __webpack_public_path__ + "img/ruanzhu2121.0704ad86.png";